module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main-box"
  }, [_c('akko-header'), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt-5 container-box"
  }, [_c('redeem-progress', {
    attrs: {
      "currentStep": _vm.registration_step
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex form-area flex-column justify-between"
  }, [_c('activation-code', {
    attrs: {
      "currentStep": _vm.registration_step,
      "checkRedemptionCode": _vm.checkRedemptionCode
    },
    model: {
      value: (_vm.redemption_code),
      callback: function($$v) {
        _vm.redemption_code = $$v
      },
      expression: "redemption_code"
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.registration_step === _vm.PERSONAL_INFO),
      expression: "registration_step === PERSONAL_INFO"
    }]
  }, [_c('personal-form', {
    attrs: {
      "title": "Personal Information",
      "subtitle": "Enter your personal information",
      "firstLabel": "Cell Phone Number",
      "secondLabel": "Email Address",
      "autoFocus": "",
      "firstValue": _vm.phone_no,
      "secondValue": _vm.email,
      "phoneError": _vm.phoneError,
      "emailError": _vm.emailError,
      "studentError": _vm.studentError,
      "emailUnfocus": _vm.email_unfocus,
      "maxLength": 14
    },
    on: {
      "update:firstValue": function($event) {
        _vm.phone_no = $event
      },
      "update:first-value": function($event) {
        _vm.phone_no = $event
      },
      "update:secondValue": function($event) {
        _vm.email = $event
      },
      "update:second-value": function($event) {
        _vm.email = $event
      },
      "update:emailUnfocus": function($event) {
        _vm.email_unfocus = $event
      },
      "update:email-unfocus": function($event) {
        _vm.email_unfocus = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.email !== '' && !_vm.emailError && !_vm.email.endsWith('.edu') && _vm.email_unfocus),
      expression: "email !== '' && !emailError && !email.endsWith('.edu') && email_unfocus"
    }],
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "cera-round-pro f5 db mb3"
  }, [_vm._v("Student Verification")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school),
      expression: "school"
    }],
    staticClass: "inter f6 input-reset w-40 ba db mr3 br2 mb4 code-input school",
    attrs: {
      "placeholder": "School Name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.school)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.school = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "f6 inter silver"
  }, [_vm._v("\n              Please upload proof of your student status (school ID, unofficial transcript, receipt of tuition paid, or class schedule)\n            ")]), _vm._v(" "), _c('div', {
    class: 'flex h4 justify-center items-center br2 w-40 tc mb5 mt3 ' + (_vm.image_file_name ? 'container-ready' : 'container-empty')
  }, [_c('input', {
    staticClass: "input-reset dn",
    attrs: {
      "id": "file",
      "type": "file",
      "accept": "image/*, .pdf,.heic,.heif,.HEIC,.HEIF"
    },
    on: {
      "change": function($event) {
        return _vm.processImage($event)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "flex justify-around items-center inter dib fw5 pv2 ph3 pointer ba bw1 f7 white br2",
    class: _vm.image_file_name ? 'bg-green b-green' : 'bg-theme b-theme',
    attrs: {
      "for": "file"
    }
  }, [_c('svg', {
    staticClass: "v-sub mr1",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "20",
      "height": "18",
      "viewBox": "0 0 20 18",
      "fill": "white"
    }
  }, [_c('path', {
    attrs: {
      "d": "M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "white"
  }, [_vm._v(_vm._s(_vm.image_file_name ? 'Replace File' : 'Upload Transcript/ID'))])])])]), _vm._v(" "), _c('personal-form', {
    attrs: {
      "title": "Payment Information",
      "subtitle": "Enter your payment related informations",
      "firstLabel": "Card Holder First Name",
      "secondLabel": "Card Holder Last Name",
      "firstValue": _vm.first_name,
      "secondValue": _vm.last_name,
      "margin": "mt4"
    },
    on: {
      "update:firstValue": function($event) {
        _vm.first_name = $event
      },
      "update:first-value": function($event) {
        _vm.first_name = $event
      },
      "update:secondValue": function($event) {
        _vm.last_name = $event
      },
      "update:second-value": function($event) {
        _vm.last_name = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt3 mb5"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "inter f6 color-theme"
  }, [_vm._v(_vm._s(_vm.cardErrorMessage))])])], 1), _vm._v(" "), _c('agreement', {
    attrs: {
      "accept": _vm.accept,
      "registrationStep": _vm.registration_step
    },
    on: {
      "update:accept": function($event) {
        _vm.accept = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorList.length > 0),
      expression: "errorList.length > 0"
    }],
    staticClass: "mb3"
  }, [_c('span', {
    staticClass: "inter-medium red mt3 mb2"
  }, [_vm._v("Error submitting registration:")]), _vm._v(" "), _vm._l((_vm.errorList), function(e, index) {
    return _c('span', {
      key: index,
      staticClass: "red",
      domProps: {
        "innerHTML": _vm._s(e)
      }
    })
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end buttons"
  }, [(_vm.registration_step > _vm.ACTIVATION_CODE) ? _c('ak-button', {
    staticClass: "w4",
    attrs: {
      "shadow": "",
      "newSecondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.setCurrentStep(_vm.registration_step - 1)
      }
    }
  }, [_vm._v("\n          Previous\n        ")]) : _vm._e(), _vm._v(" "), _c('ak-button', {
    staticClass: "ml3 w4",
    attrs: {
      "newDisabled": !_vm.enableButton,
      "shadow": "",
      "newPrimary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextStep.apply(null, arguments)
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.registration_step === _vm.TERMS_CONDS ? 'Register' : 'Continue') + "\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-row justify-start mb3"
  }, [_c('div', {
    staticClass: "w-40 mr3",
    attrs: {
      "id": "card-number"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row w-40"
  }, [_c('div', {
    staticClass: "small-input w-50 mr3",
    attrs: {
      "id": "card-expiry"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small-input w-50",
    attrs: {
      "id": "card-cvc"
    }
  })])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0da16628", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0da16628","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/StudentRedeem.vue
// module id = 701
// module chunks = 0